import { FC } from 'react';

import { Box } from '@mui/material';
import { IGiaItem } from 'api/types';
import ResultDoughnut from 'components/common/ResultDoughnut';
import { useGiaExamCardProperties } from 'hooks';

import BaseCard from '../BaseCard';
import * as styles from './styles';

interface IExamGiaCardProps {
  exam: IGiaItem;
  onView: () => void;
}

const ExamGiaCard: FC<IExamGiaCardProps> = ({ exam, onView }) => {
  const { name, formaGia } = exam;

  const { doughnutTotal, doughnutData, doughnutColor, resultDate, lowerHint } = useGiaExamCardProperties(exam);

  const doughnutElement = (
    <Box sx={styles.chart}>
      <ResultDoughnut total={doughnutTotal ?? '-'} data={doughnutData} color={doughnutColor} lowerHint={lowerHint} />
    </Box>
  );

  return (
    <BaseCard
      title={name ?? undefined}
      place={formaGia}
      dateElement={resultDate}
      rightElement={doughnutElement}
      onView={onView}
    />
  );
};

export default ExamGiaCard;
